export default "__VITE_ASSET__DHzuEKAz__"